module.exports = __webpack_public_path__ + "static/media/yvesDerains.137cdad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/yvesDerains.jpg
// module id = 1704
// module chunks = 1